import dayjs, { Dayjs } from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(advancedFormat);
dayjs.extend(updateLocale);

dayjs.extend(relativeTime, {
  thresholds: [
    { l: 's', r: 1 },
    { l: 'm', r: 1 },
    { l: 'mm', r: 59, d: 'minute' },
    { l: 'h', r: 1 },
    { l: 'hh', r: 23, d: 'hour' },
    { l: 'd', r: 1 },
    { l: 'dd', r: 29, d: 'day' },
    { l: 'M', r: 1 },
    { l: 'MM', r: 11, d: 'month' },
    { l: 'y', r: 1 },
    { l: 'yy', d: 'year' }
  ]
});

dayjs.updateLocale('en', {
  relativeTime: {
    future: "in %s",
    past: "%s ago",
    s: 'a few seconds',
    m: "a minute",
    mm: "%d minutes",
    h: "an hour",
    hh: "%d hours",
    d: "a day",
    dd: "%d days",
    M: "1 month",
    MM: "%d months",
    y: "a year",
    yy: "%d years"
  }
});

namespace DateTimeUtils {
  export function getCurrentTimeOfDayMessage() {
    const curHours = dayjs().local().hour();

    if (curHours < 12) {
      return 'Good morning';
    } else if (curHours < 18) {
      return 'Good afternoon';
    } else {
      return 'Good evening';
    }
  }

  export function relativeTimeFromNow(date: Dayjs | string | Date) {
    return dayjs(date).fromNow();
  }

  export function relativeTimeFrom(startDate: Dayjs | string | Date = new Date(), endDate: Dayjs | string | Date) {
    return dayjs(endDate).from(startDate, true)
  }
  
  export function formatDate(date: Dayjs | string | Date, format = 'MMM D, YYYY') {
    return dayjs(date).format(format);
  }
}

export default DateTimeUtils;